// extracted by mini-css-extract-plugin
export default {"cardTitle":"JobZone_cardTitle__5NlgH"};